import { useState, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import _get from 'lodash/get';
import { Banner } from 'commons/models/banner.model';

import { AppContext } from 'commons-ui';

import { hydrateFormData, dehydrateFormData } from '../../utils/formDataParser';
import useService from '../../utils/useService';
import { UserlistData } from '../../utils/constants';

const useEdit = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { app, showAlert } = useContext(AppContext);
	const history = useHistory();
	const location = useLocation();
	const { requestCreateUserSegment, requestUpdateBanner } = useService();

	const updateBanner = (updatedData: { bannerData: Banner; userListData?: UserlistData }) => {
		setShowLoader(true);

		const { bannerData, userListData } = updatedData;

		requestUpdateBanner(app.appName, bannerData).then(
			(res: any) => {
				if (res?.status !== 200 || !res?.data?.success) {
					showAlert(res?.data?.error || 'Error occured while updating the banner', { type: 'error' });
					setShowLoader(false);
					return;
				}

				if (userListData) {
					requestCreateUserSegment(app.appName, userListData).then((userRes: any) => {
						if (userRes.status !== 200 || !userRes.data.success) {
							showAlert(
								`Error: Banner was successfully updated. Error occured while creating user segment. Please edit the banner to create the segment again`,
								{ type: 'error' }
							);
						} else {
							showAlert('Banner updated');
						}
						setShowLoader(false);
						history.goBack();
					});
				} else {
					showAlert('Banner updated');
					setShowLoader(false);
					history.goBack();
				}
			},
			(err: any) => {
				showAlert(`Error: ${err.response.data.error}`, { type: 'error' });
				setShowLoader(false);
			}
		);
	};

	const handleFormSubmit = (submittedData: any) => {
		updateBanner(dehydrateFormData(submittedData));
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return {
		data: hydrateFormData(_get(location, ['state', 'rowData'])),
		showLoader,
		handleFormSubmit,
		handleFormCancel,
		setShowLoader
	};
};

export default useEdit;
